import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-embed_miro_icon",
  "use": "icon-embed_miro_icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-embed_miro_icon\">\n<path d=\"M1 1H19V19H1V1Z\" fill=\"#FFD02F\" />\n<path d=\"M13.2656 3.3999H11.3441L13.05 6.04365L9.44357 3.3999H7.52205L9.22794 6.86415L5.62153 3.3999H3.70001L5.37778 7.87215L3.70001 16.5999H5.62153L9.22794 7.24178L7.52205 16.5999H9.44357L13.05 6.42165L11.3441 16.5999H13.2656L16.9001 5.41928L13.2656 3.3999Z\" fill=\"#050038\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol